import { Outlet } from "react-router";

import PageWrapper from "@/components/ui/PageWrapper";

function TrajectoryCreation() {
  return (
    <PageWrapper>
      <div className="my-lg grid grid-cols-4">
        <div className="col-start-2 col-end-4 justify-center">
          <Outlet />
        </div>
      </div>
    </PageWrapper>
  );
}

export default TrajectoryCreation;
